import { Actor, CollisionType, Color, vec } from 'excalibur';

import { CONFIG } from '../config';
import { Resources } from '../resources';

export class Background extends Actor {
  constructor() {
    super({
      name: 'Background',
      pos: vec(0, 0),
      anchor: vec(0, 0),
      collisionType: CollisionType.Passive,
      width: CONFIG.screen.width,
      height: CONFIG.screen.height,
      color: Color.Orange,
    });
  }

  override onInitialize(): void {
    this.graphics.use(Resources.background.toSprite());
    // The raw asset is actually double the size we need, scale down
    this.graphics.current?.scale.setTo(0.5, 0.5);
  }
}
